import React from 'react'

function CardWaveSlope({bgColor = "white", strokeColor="#0044c6"}) {
  return (
      <svg className='wave-separator' preserveAspectRatio="xMinYMax meet" /*width="366" height="105"*/ viewBox="0 0 366 105" fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* <mask id="mask0_3857_184700" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="366" height="105">
              <rect width="366" height="105" fill="#D9D9D9" />
          </mask> */}
          {/* <g mask="url(#mask0_3857_184700)"> */}
              <path fill={bgColor} d="M0 100.759L366 2V105H0V100.759Z" />
              <path fill={strokeColor} d="M-0.73325 98.6188L366.502 0.00881595L367.055 6.02931L-0.18862 104.233L-0.404849 101.896L-0.73325 98.6188Z" />
          {/* </g> */}
      </svg>
  )
}

export default CardWaveSlope